import { JSX, useState, useEffect, useRef } from 'react';
import WindowBar from '../common/windowBar/windowBar';
import TodoIcon from '../assets/images/svgs/bookmark-Pixel.svg'
import MenuButton from '../common/windowMenu/menuButton';
import NoteManager from '../todolist/data/noteManager';
import {NoteProps} from '../note/note';
import NoteDropdown from './note-dropdown';
import NoteView from './noteView';
import TodoView from '../todo-page/todoView/todoView';
import { TodoTask } from '../todolist/add-todo/addTodoList';
import TodoManager from '../todolist/data/todoManager';
import EditTodo from '../todo-page/editTodo';
import Loading from '../common/Loading/loading';

const NotePage = ({ setClosePage }: { setClosePage: () => void }): JSX.Element => {

    const noteManager = NoteManager.getInstance();
    const [title, setTitle] = useState('TodoList: All');
    const [notes, setNotes] = useState<NoteProps[]>();
    const [isLoading, setIsLoading] = useState(true);
    const [displayNote, setDisplayNote] = useState<NoteProps>(null);
    const noteButtonRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const [openMenu, setOpenMenu] = useState<JSX.Element>(<></>);
    const [noteDropdownOpen, setNoteDropdownOpen] = useState(false);
    const [todos, setTodos] = useState<TodoTask[]>([]);
    const [displayTodos, setDisplayTodos] = useState<TodoTask[]>([]);
    const [editTodoPage, setEditTodoPage] = useState<JSX.Element>(<></>);
    const [isTodoEdit, setIsTodoEdit] = useState(false);
    const [isNoteEdit, setIsNoteEdit] = useState(false);

    useEffect(() => {
        if (isLoading)
            return;
        else if(notes.length != 0) {
            setDisplayNote(notes[0]);
        }
    }, [isLoading]);

    useEffect(() => {
        if(displayNote != null)
            setTitle(displayNote.title);
    }, [displayNote]);

    const refreshNotes = async () => {
        try {
            const fetchedNotes = await noteManager.getNotes(); // Now waits for initialization
            setNotes([...fetchedNotes]);
        } catch (error) {
            console.error('Failed to fetch todos:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        refreshNotes();
    }, []);

    useEffect(() => {
        // Subscribe to updates
        const unsubscribe = noteManager.subscribe(refreshNotes);
        
        // Initial load
        refreshNotes();

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    const todoManager = TodoManager.getInstance();
    const refreshTodos = async () => {
        try {
            const fetchedTodos = await todoManager.getTodos(); // Now waits for initialization
            setTodos([...fetchedTodos]);
        } catch (error) {
            console.error('Failed to fetch todos:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        refreshTodos();
    }, []);

    useEffect(() => {
        // Subscribe to updates
        const unsubscribe = todoManager.subscribe(refreshTodos);
        
        // Initial load
        refreshTodos();

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        filterTodos();
    },[todos, displayNote]);

    useEffect(() => {
        if (displayNote != null) 
            console.log("displayNote", displayNote);
        if (displayNote != null) 
            setDisplayNote(notes.find(note => note.id === displayNote.id));
    },[notes]);

    const filterTodos = () => {
        const filteredTodos = todos.filter(todo => todo.noteId != null && todo?.noteId === displayNote?.id);
        setDisplayTodos(filteredTodos);
    }

    if (isLoading) {
        return <div><Loading/></div>;
    }

    const handleNoteClick = () => {
        console.log("note dropdown button click");
        if (noteButtonRef.current && containerRef.current) {
            const buttonRect = noteButtonRef.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();
            
            console.log(`button rect ${buttonRect}`);
            // Calculate position relative to container
            setMenuPosition({
                ...menuPosition,  // Spread existing properties
                top: buttonRect.bottom - containerRect.top,
                left: buttonRect.left - containerRect.left
            });

            setNoteDropdownOpen(!noteDropdownOpen);
            setOpenMenuElement(<NoteDropdown setSelectedNote={setDisplayNote} closeWindow={closeNoteDropdown}/>);
        }
    }

    const closeNoteDropdown = () => {
        setNoteDropdownOpen(false);
        setOpenMenuElement(<></>);
    }

    const setOpenMenuElement = (element: JSX.Element) => {
        setOpenMenu(element);
    }

    const setCloseEditPage = () => {
        setIsTodoEdit(false);
    }
    
    const openEditPage = (todo: TodoTask) => {
        setIsTodoEdit(true);
        setEditTodoPage(<EditTodo todo={todo} setClosePage={setCloseEditPage}/>)
    }

    const updateNoteContent = async (content: string) => {
        setDisplayNote({...displayNote, content: content});
    }

    return (
        <div className='addTodo-outter outter-container' ref={containerRef}>
          <div className='pixel-container-back'/>
          <div className='pixel-container-top addTodo-container'>
            <div className='addPage-inner'>
                <WindowBar IconSrc={TodoIcon} title={title} onClick={setClosePage}/>
                <div className='main-pixel-container page-content'>
                    <div ref={noteButtonRef}>
                        <MenuButton title='Notes' isChosen={null} onClick={handleNoteClick}/>
                    </div>
                    <div className="divider-horizontal"/>
                        {displayNote !== null ? 
                            (<div>
                                <NoteView note={displayNote} updateNoteContent={updateNoteContent}/>
                            </div>)
                            : (<></>)
                        }
                    <div className="divider-horizontal"/>
                    <div className='todoPage-todos'>
                        {displayTodos.map(todo => (
                            <TodoView todo={todo}
                                onUpdate={refreshNotes}
                                openEdit={() => openEditPage(todo)}
                            />
                        ))}
                    </div>
                </div>
            </div>
          </div>
          <div className='menu-overlay' style={{
                position: 'absolute',
                top: menuPosition.top,
                left: menuPosition.left,
                zIndex: 1000
            }}>
                { noteDropdownOpen? (openMenu):(<></>)}
                {isTodoEdit? (editTodoPage):(<></>)}
            </div>
            {isLoading? (<Loading/>):(<></>)}
        </div>
    ); 
};

export default NotePage;